export default {
  WIDGET: 'widget',
  FULL_SCREEN_MODALS: 'full-screen-modals',
};



// WEBPACK FOOTER //
// ./src/shared/constants/application-names.js